import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

class FilterButton extends Component {
    handleClick = (event) => {
        if (this.props.args) {
            this.props.onToggle(...this.props.args);
        } else if (this.props.arg !== undefined) {
            this.props.onToggle(this.props.arg);
        } else {
            this.props.onToggle(event);
        }
    }

    icon() {
        if (!this.props.default) return faCircleExclamation;
        return null;
    }

    render() {
        if (!this.props.visible) return null;
        const icon = this.icon();

        return (
            <button type="button" className="btn btn-primary text-nowrap" onClick={this.handleClick}>
                {icon ? <FontAwesomeIcon icon={icon} /> : null} {this.props.label}
            </button>
        );
    }
}

FilterButton.defaultProps = {
    visible: true,
    default: true,
    open: true
};

export default FilterButton;